import { render } from "./SharedProfileDataForm.vue?vue&type=template&id=400f0ed0"
import script from "./SharedProfileDataForm.vue?vue&type=script&lang=js"
export * from "./SharedProfileDataForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__